// extracted by mini-css-extract-plugin
module.exports = {"root":"AppPage_root__31C61"};